import { DEFAULT_SHEET_NAME } from "../constants";
import type { TemplatesValue } from "../types";
import {
  AmadeusGroupUser as FunctionCode,
  AmadeusSystem as System,
  CaseHasBeenGranted,
  CodePcc,
  DetailedDescriptionOfTheRequest,
  Email,
  EmployeeCode,
  IdUser,
  MEDIUM_ITEM_SIZE,
  PhoneNumber,
  Position,
  Request,
  Users,
  WorkingDepartment,
} from "./_fields";

type EprTemplate = {
  Users: string;
  EmployeeCode: string;
  WorkingDepartment: string;
  Title: string;
  System: string;
  FunctionCode: string;
  CaseHasBeenGranted: string;
  Request: string;
  DetailedDescriptionOfTheRequest: string;
  CodePcc: string;
  Email: string;
  PhoneNumber: number;
  IdUser: number;
};

export const eprTemplate: TemplatesValue<EprTemplate> = {
  fileName: "DanhSachCapAmadeus",
  sheet: DEFAULT_SHEET_NAME,
  structures: [
    CodePcc,
    Users,
    EmployeeCode,
    WorkingDepartment,
    {
      ...Position,
      itemSize: MEDIUM_ITEM_SIZE,
    },
    System,
    FunctionCode,
    CaseHasBeenGranted,
    Request,
    DetailedDescriptionOfTheRequest,
    Email,
    {
      ...PhoneNumber,
      header: "SĐT",
    },
    IdUser,
  ],
  fields: [
    "CodePcc",
    "Users",
    "EmployeeCode",
    "WorkingDepartment",
    "Title",
    "System",
    "FunctionCode",
    "CaseHasBeenGranted",
    "Request",
    "DetailedDescriptionOfTheRequest",
    "Email",
    "PhoneNumber",
    "IdUser",
  ],
};
